import { MdFolder } from 'react-icons/md';
import { generatePath, Link } from 'react-router-dom';
import { Column } from 'react-table';
import { Icon, Time } from '@nbirl/nbi-common-ui-libs';

import { PATHS } from '../../../../../shared/constants';
import { Folder } from '../../models';

export const columns: Column<Folder>[] = [
  {
    Header: () => <div className="ml-8">Name</div>,
    accessor: 'name',
    Cell: ({
      value,
      cell: {
        row: { original },
      },
    }) => (
      <div className="flex items-center space-x-2">
        <Icon icon={<MdFolder className="text-gray-200 flex-shrink-0" />} />
        <Link
          to={generatePath(PATHS.Documents, { folderId: original.id })}
          className="hover:underline text-md auto-table-break-words"
        >
          {value}
        </Link>
      </div>
    ),
  },
  {
    Header: 'Added by',
    id: 'addedBy',
    accessor: (row) => row.creator?.name,
  },
  {
    Header: 'Date added',
    accessor: 'dateAdded',
    Cell: ({ value }) =>
      value ? <Time value={value} representation="date" /> : null,
  },
];
